export const notificationTranslations = {
    deleteContact: {
        title: 'Contact Deleted',
        message: 'Contact was successfully deleted.'
    },
    deleteContactFailed: {
        title: 'Delete Contact Failed',
        message: 'Contact could not be deleted. Please try again.'
    },
    createdContact: {
        title: 'Contact Created',
        message: 'New contact was successfully created.'
    },
    updatedContact: {
        title: 'Contact Updated',
        message: 'Contact was successfully updated.'
    },
    updatedClient: {
        title: 'Client Updated',
        message: 'Client was successfully updated.'
    },
    errorUpdatingClient: {
        title: 'Error Updating Client',
        message: 'There was an error updating the client.'
    },
    primaryContactEmailAlreadyInUser: {
        title: 'Primary contact email already in use',
        message:
            'The email associated with the selected primary contact is already in use by another platform user. Please double check and consider using a different primary email for this contact.'
    },
    createdClient: {
        title: 'Client Create',
        message: 'Client was successfully created.'
    },
    errorCreatingClient: {
        title: 'Error Creating Client',
        message: 'There was an error creating the client.'
    },
    createdLoan: {
        title: 'Loan Created',
        message: 'Loan was successfully created.'
    },
    errorCreatingLoan: {
        title: 'Error Creating Loan',
        message: 'There was an error creating the loan.'
    },
    updatedLoan: {
        title: 'Loan Updated',
        message: 'Loan was successfully updated.'
    },
    errorUpdatingLoan: {
        title: 'Error Updating Loan',
        message: 'There was an error updating the loan.'
    },
    resetProgress: {
        title: 'New dependencies',
        message:
            'Due to a the change which was just made, there may be additional questions which need to be answered, or answers you have already given may now be invalid. Please continue through form and check your answers.'
    },
    reassignPrimary: {
        title: 'Primary contact reassigned',
        message: 'The primary contact for this organization has been successfully reassigned.'
    },
    loggedOut: {
        title: 'Logged out!',
        message: 'You have been successfully logged out of the BEEP platform.'
    },
    logInEmailSent: {
        title: 'Log In Email dispatched!',
        message: 'Please check your email for a sign in link.'
    },
    incorrectEmail: {
        title: 'Email confirmation failed!',
        message:
            'The email you provided does not match the one in our system. Please reopen the sign in link we sent you and try again'
    },
    invalidEmailLink: {
        title: 'There is an issue with this link!',
        message:
            'This email link could have expired or might have already been used to log in. Please enter your email into the login field to request a new login link.'
    },
    loggedInWithGoogle: {
        title: 'Logged in with Google!',
        message: 'You have successfully logged in with Google.'
    },
    loggedInWithMicrosoft: {
        title: 'Logged in with Microsoft!',
        message: 'You have successfully logged in with Microsoft.'
    },
    userUpdateSuccessful: {
        title: 'User successfully updated!',
        message: 'You have successfully updated the user data.'
    },
    userUpdateFailed: {
        title: 'Error updating user!',
        message: 'There was an error updating user data. Please try again later.'
    },
    userCreateSuccessful: {
        title: 'User successfully created!',
        message: 'You have successfully created a new user.'
    },
    userCreateFailed: {
        title: 'Error creating user!',
        message: 'There was an error creating a new user. Please try again later.'
    },
    signinEmailUpdated: {
        title: 'Email successfully updated!',
        message:
            'You have successfully updated your sign in email. In future, please use the new email when logging in.'
    },
    emailUpdateFailed: {
        title: 'Error updating email!',
        message: 'There was an error updating your email. Please try again later.'
    },
    inviteEmailSend: {
        title: 'Invite email sent!',
        message: 'An invite to join your organization was dispatched to {{email}}'
    },
    credentialsRevoked: {
        title: 'Credentials revoked!',
        message: 'Access to your organization on the BEEP platform has been revoked for the following email: {{email}}'
    },
    approveSurvey: {
        title: 'Survey Accepted!',
        message: 'Answers for this survey have been review and accepted.'
    },
    rejectSurvey: {
        title: 'Survey Rejected!',
        message:
            'Answers for this survey have been rejected. The survey will be passed back to the client for them to make necessary amendments.'
    },
    onboardingSubmitted: {
        title: 'Onboarding Completed!',
        message: 'Thank you for reviewing the information we have on file.'
    },
    onboardingFailed: {
        title: 'Error Submitting Onboarding Survey!',
        message:
            'There has been an error finishing the onboarding process. Please try again and if there are still issues, please contact CIC directly.'
    },
    surveySubmitted: {
        title: 'Survey Submitted!',
        message:
            'Thank you for submitting this survey. We will review and contact you if we have any further questions.'
    },
    surveySubmissionFailed: {
        title: 'Error Submitting Survey!',
        message:
            'There has been an error submitting this survey. Please try again and if there are still issues, please contact CIC directly.'
    },
    enrollSuccess: {
        title: 'Client successfully enrolled!',
        message:
            'This client has been enrolled in BEEP surveys. The primary contact should now receive an email inviting them to onboard.'
    },
    enrollFailed: {
        title: 'Client enrollment failed!',
        message:
            'There was an error enrolling this client in BEEP surveys. Please try again or contact Hivemetric for assistance'
    },
    loanGroupCreateSuccessful: {
        title: 'Loan Group created!',
        message: 'This new loan group has been successfully created'
    },
    loanGroupCreateFailure: {
        title: 'Loan Group not created!',
        message: 'There was a problem saving this loan group'
    },
    loanGroupEditSuccessful: {
        title: 'Loan Group updated!',
        message: 'Changes to loan group have been successfully saved'
    },
    loanGroupEditFailure: {
        title: 'Loan Group update failed!',
        message: 'There was a problem saving the changes to this loan group'
    },
    surveyBatchCreateSuccessful: {
        financial: {
            title: '{{generatedCount}} financial surveys created!',
            message: 'You can filter Upcoming surveys on the surveys table to see the batch of scheduled surveys'
        },
        biannual: {
            title: '{{generatedCount}} surveys created!',
            message: 'You can filter Upcoming surveys on the surveys table to see the batch of scheduled surveys'
        }
    },
    surveyBatchCreatedNoSurveys: {
        financial: {
            title: 'No financial surveys created!',
            message: 'No organizations are eligible for a new survey for the timeframe chosen.'
        },
        biannual: {
            title: 'No surveys created!',
            message: 'There are no eligible loan groups for the selected parameters'
        }
    },
    surveyBatchCreateFailure: {
        title: 'Failed to create survey batch!',
        message: 'There was a problem creating the survey batch requested'
    },
    surveyDispatchSuccessful: {
        title: 'Survey dispatched!',
        message: 'The primary contact for this organization will be notified via email'
    },
    surveyDispatchFailure: {
        title: 'Survey dispatch failed!',
        message: 'There was a problem dispatching the survey to the primary contact'
    },
    surveyDispatchReminderSuccessful: {
        title: 'Reminder dispatched!',
        message: 'The primary contact for this organization will receive an email notification'
    },
    surveyDispatchReminderFailure: {
        title: 'Reminder dispatch failed!',
        message: 'There was a problem dispatching the survey reminder to the primary contact'
    },
    surveyDeleteSuccessful: {
        title: 'Survey deleted!',
        message: 'The survey was successfully deleted'
    },
    surveyDeleteFailure: {
        title: 'Survey deletion failed!',
        message: 'There was a problem deleting the survey. Please try again later or contact a member of the CIC team'
    },
    surveyGenerationNotifications: {
        financial: {
            existing_survey: {
                title: 'Could not create survey!',
                message: 'A financial survey for the selected target year already exists'
            }
        }
    },
    surveyCreateSuccess: {
        financial: {
            title: 'Financial survey created!',
            message: 'The financial survey was successfully generated'
        }
    },
    onboardingReminder: {
        title: 'Reminder sent!',
        message: 'An email reminder has been dispatched to the primary contact for this organization'
    },
    onboardingReminderFailed: {
        title: 'Reminder failed to send!',
        message: 'There was a problem dispatching the email reminder. Please try again later.'
    }
};
